<template>
  <div class="nav">
    <div
      class="nav__block"
      @click="resetSearch()"
    >
      <div class="nav__logo" />
    </div>

    <div class="nav__block">
      <LayoutHeaderControls
        :bottomBorder="true"
        @controlsChanged="toggleControls"
      />
    </div>

    <div class="nav__block nav__block--right aiControls">
      <LayoutButtonGroup>
        <FormButton
          :text="windowWidth < 960 ? 'AI' : 'Statzon AI'"
          :textOnly="true"
          :condensedText="windowWidth < 480 ? true : false"
          :value="''"
          color="blue"
          defaultColor="blue"
          textColor="blue"
          variant="dark"
          :bottomBorder="true"
          :icon="aiIcon"
          iconSize="lg"
          :selected="false"
          :disabled="false"
          @click.native="ai()"
        />
      </LayoutButtonGroup>

      <FormButton
        v-if="isAuthenticated"
        size="sm"
        variant="header"
        :circle="true"
        :borderless="true"
        :defaultColor="totalSelectedFilters > 0 ? 'blue' : 'light'"
        color="blue"
        icon='<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M15.137 3.945c-.644-.374-1.042-1.07-1.041-1.82v-.003c.001-1.172-.938-2.122-2.096-2.122s-2.097.95-2.097 2.122v.003c.001.751-.396 1.446-1.041 1.82-4.667 2.712-1.985 11.715-6.862 13.306v1.749h20v-1.749c-4.877-1.591-2.195-10.594-6.863-13.306zm-3.137-2.945c.552 0 1 .449 1 1 0 .552-.448 1-1 1s-1-.448-1-1c0-.551.448-1 1-1zm3 20c0 1.598-1.392 3-2.971 3s-3.029-1.402-3.029-3h6z"/></svg>'
        iconSize="md"
        :content="getNotificationTooltip()"
        v-tippy="{ theme: 'statzon', placement: 'top', arrow: true, animation: 'scale' }"
        :highlighted="totalSelectedFilters > 0 ? true : false"
        :selected="addingNotification"
        :disabled="totalSelectedFilters <= 0"
        @click.native="toggleNotification()"
      />

      <FormButton
        v-if="isAuthenticated"
        variant="initials"
        :text="userInitials"
        color="blue"
        :textOnly="true"
        :borderless="true"
        :selected="false"
        :disabled="false"
        content="Settings"
        v-tippy="{ theme: 'statzon', placement: 'bottom', arrow: true, animation: 'scale' }"
        @click.native="settings()"
      />

      <template v-else>
        <LayoutButtonGroup :borderless="windowWidth < 960 ? false : true">
          <FormButton
            :variant="windowWidth < 960 ? 'dark' : 'register'"
            :text="windowWidth < 960 ? false : 'Register'"
            color="blue"
            :bottomBorder="windowWidth < 960 ? true : false"
            :icon="windowWidth < 960 ? registerIcon : false"
            iconSize="lg"
            :textOnly="true"
            :borderless="windowWidth < 960 ? false : true"
            :selected="false"
            :disabled="false"
            @click.native="register()"
          />

          <FormButton
            :variant="windowWidth < 960 ? 'dark' : 'login'"
            :text="windowWidth < 960 ? false : 'Login'"
            color="blue"
            :bottomBorder="windowWidth < 960 ? true : false"
            :icon="windowWidth < 960 ? loginIcon : false"
            iconSize="xl"
            :textOnly="true"
            :borderless="windowWidth < 960 ? false : true"
            :selected="false"
            :disabled="false"
            @click.native="login()"
          />
        </LayoutButtonGroup>
      </template>
    </div>
  </div>
</template>

<script>
import LayoutHeaderControls from '@/components/layout/HeaderControls.vue'
import LayoutButtonGroup from '@/components/layout/ButtonGroup.vue'
import FormButton from '@/components/form/Button.vue'
import helperMethods from '@/helpers/utility.js'

export default {
  components: {
    LayoutHeaderControls,
    LayoutButtonGroup,
    FormButton
  },
  data () {
    return {
      windowWidth: window.innerWidth
    }
  },
  computed: {
    isAuthenticated () {
      return this.$store.getters['user/isAuthenticated']
    },
    userInitials () {
      return this.$store.getters['user/getInitials']
    },
    selectedFilters () {
      return this.$store.getters['search/getSelectedFilters']
    },
    totalSelectedFilters () {
      let total = 0

      if (this.selectedFilters) {
        for (const [key, value] of Object.entries(this.selectedFilters)) {
          if (this.selectedFilters[key] && this.selectedFilters[key].length > 0) {
            total += this.selectedFilters[key].length
          }
        }
      }

      return total
    },
    addingNotification () {
      return this.$store.getters['search/getAddingNotification']
    },
    currentView () {
      return this.$route.name
    },
    registerIcon () {
      return '<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M9 19h-4v-2h4v2zm2.946-4.036l3.107 3.105-4.112.931 1.005-4.036zm12.054-5.839l-7.898 7.996-3.202-3.202 7.898-7.995 3.202 3.201zm-6 8.92v3.955h-16v-20h7.362c4.156 0 2.638 6 2.638 6s2.313-.635 4.067-.133l1.952-1.976c-2.214-2.807-5.762-5.891-7.83-5.891h-10.189v24h20v-7.98l-2 2.025z"/></svg>'
    },
    loginIcon () {
      return '<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M8 9v-4l8 7-8 7v-4h-8v-6h8zm2-7v2h12v16h-12v2h14v-20h-14z"/></svg>'
    },
    aiIcon () {
      if (this.windowWidth < 480) {
        return false
      }

      return '<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M19 24h-14v-2h14v2zm-10-24c.542 6.292-5 8.458-5 14 0 3.764 3.084 6.42 6.594 7.005-1.094-1.755-.073-4.286 1.406-5.693 1.531 1.469 2.344 4.156 1.281 5.688 3.868-.75 6.719-3.858 6.719-7.833 0-3.625-1.833-7.042-5.291-9.167.822 2.281-.271 4.365-1.334 5.083.063-2.921-1-7.255-4.375-9.083z"/></svg>'
    }
  },
  methods: {
    toggleControls (setting, value) {
      this.$store.dispatch('app/setSettings', { 'name': setting, 'value': value })

      if (setting === 'search.view') {
        if (['search', 'datasets', 'pdfs', 'news'].includes(value)) {
          let view = value === 'search' && this.totalSelectedFilters === 0 ? '' : value
          this.$router.push('/' + view + '?' + this.$store.getters['search/getFiltersQuery'](false, false) + this.$store.getters['search/getControlsQuery'](value, 'client'))
          this.sendGoogleAnalyticsEvent('misc_click', 'nav_' + value, this.$route.name, this.$store.getters['user/getSubscriptionStatus'])
        }
      }
    },
    resetSearch () {
      window.scrollTo(0,0)
      this.$store.dispatch('search/setInput', '')

      if (this.$route.path !== '/') {
        this.$store.dispatch('app/setSettings', { 'name': 'datasets.access', 'value': 'all' }) // TODO: Create app/resetState|Settings function?
        this.$store.dispatch('app/setSettings', { 'name': 'datasets.sort', 'value': 'relevance' })
        this.$store.dispatch('app/setSettings', { 'name': 'pdfs.access', 'value': 'all' })
        this.$store.dispatch('app/setSettings', { 'name': 'pdfs.sort', 'value': 'relevance' })
        this.$store.dispatch('app/setSettings', { 'name': 'news.access', 'value': 'all' })
        this.$store.dispatch('app/setSettings', { 'name': 'news.sort', 'value': 'relevance' })
        this.$store.dispatch('search/resetState')
        this.$store.dispatch('search/setInput', '')
        this.$router.push('/')
        this.sendGoogleAnalyticsEvent('misc_click', 'nav_reset', this.$route.name, this.$store.getters['user/getSubscriptionStatus'])
      }
    },
    toggleNotification () {
      if (this.totalSelectedFilters > 0 && this.addingNotification === false) {
        this.$store.dispatch('search/setAddingNotification', true)
      } else {
        this.$store.dispatch('search/setAddingNotification', false)
      }
    },
    getNotificationTooltip () {
      if (this.isAuthenticated === false) {
        return 'Login to create <u>email</u> notifications'
      } /*else if (this.currentView === 'News' && (!this.selectedFilters.queries || (this.selectedFilters.queries && this.selectedFilters.queries.length <= 0))) {
        return 'Use <i>free text search</i> to create <u>news</u> notification'
      }*/ else if (this.totalSelectedFilters <= 0) {
        return 'Add filters to create <u>email</u> notification'
      }

      return 'Create new <u>email</u> notification'
    },
    settings () {
      this.$router.push('/settings/details')
    },
    ai () {
      this.sendGoogleAnalyticsEvent('misc_click', 'nav_ai', this.$route.name, this.$store.getters['user/getSubscriptionStatus'])
      window.location = 'https://ai.statzon.com'
    },
    register () {
      this.sendGoogleAnalyticsEvent('misc_click', 'nav_register', this.$route.name, this.$store.getters['user/getSubscriptionStatus'])
      this.$router.push('/register')
    },
    login () {
      this.sendGoogleAnalyticsEvent('misc_click', 'nav_login', this.$route.name, this.$store.getters['user/getSubscriptionStatus'])
      this.$router.push('/login')
    },
    resize () {
      this.windowWidth = window.innerWidth
    },
    async logout () {
      await this.$store.dispatch('user/logout')
      this.$router.push('/login')
    },
    ...helperMethods
  },
  created () {
    window.addEventListener('resize', this.resize)
  },
  unmounted () {
    window.removeEventListener('resize', this.resize)
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.nav {
  @include font('content--md', $white, 0.8);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;

  &__block {
    margin: 0 1px 0 0;

    &--right {
      display: flex;
      justify-self: right;
      margin-left: auto;
    
    }

    &:first-child {
      cursor: pointer;
    }
  }

  &__logo {
    position: relative;
    width: 28px;
    height: 28px;
    background-image: url('/img/statzon_z_white.png');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: 0px 0px;
    z-index: 10;

    @media screen and (min-width: $breakpointMd) {
      width: 110px;
      height: 16px;
      background-image: url('/img/statzon_logo_white.svg');
      margin: 10px 8px 10px 4px;
    }

    @media screen and (min-width: $breakpointLg) {
      width: 120px;
      height: 18px;
    }
  }
}

.aiControls {
  display: flex;
  justify-content: flex-end;
  height: 40px;

  @media screen and (min-width: $breakpointLg) {
    height: 44px;
  }
}

</style>
